import { render, staticRenderFns } from "./ModalVerHistorico.vue?vue&type=template&id=26e44fc0&scoped=true&"
import script from "./ModalVerHistorico.vue?vue&type=script&lang=ts&"
export * from "./ModalVerHistorico.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerHistorico.vue?vue&type=style&index=0&id=26e44fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e44fc0",
  null
  
)

export default component.exports